/**
 * Single source of truth for the LienLift Direct brand mark.
 * Uses the transparent logo PNG in /public/logo.png.
 */
export default function BrandLogo({ height = 32, className = "", linkTo = null, alt = "LienLift Direct" }) {
    return (
        <img
            src="/logo.png"
            alt={alt}
            style={{ height, width: "auto" }}
            className={`block select-none ${className}`}
            draggable={false}
            data-testid="brand-logo"
        />
    );
}
